export * from './ShoppingBagView';
